import { gql } from "apollo-boost"

export const Users = gql`
{
    allUsers{
    id
    type
    role
    name
    address {
      city
      state
    }
  birthday
  email
  proposes{
      id
  }
  proposesFrom {
      id
  }
  ranks{
      id
  }
  status
  type
  anuncios {
      id
      skill {
          id
          name
      }
  }
  phoneverif
  }
}
`

export const CountUsers = `
{
    total: _allPlayersMeta{
        count
    }

    profissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
        }
    ){
        count
    }

    cliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
        }
    ){
        count
    }

}
`

export const CountUsersStates = `
{
    ACtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "AC"
            }
        }
    ){
        count
    }

    ACprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "AC"
            }
        }
    ){
        count
    }

    ACcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "AC"
            }
        }
    ){
        count
    }

    ALtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "AL"
            }
        }
    ){
        count
    }

    ALprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "AL"
            }
        }
    ){
        count
    }

    ALcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "AL"
            }
        }
    ){
        count
    }

    APtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "AP"
            }
        }
    ){
        count
    }

    APprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "AP"
            }
        }
    ){
        count
    }

    APcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "AP"
            }
        }
    ){
        count
    }

    AMtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "AM"
            }
        }
    ){
        count
    }

    AMprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "AM"
            }
        }
    ){
        count
    }

    AMcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "AM"
            }
        }
    ){
        count
    }

    BAtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "BA"
            }
        }
    ){
        count
    }

    BAprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "BA"
            }
        }
    ){
        count
    }

    BAcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "BA"
            }
        }
    ){
        count
    }

    CEtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "CE"
            }
        }
    ){
        count
    }

    CEprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "CE"
            }
        }
    ){
        count
    }

    CEcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "CE"
            }
        }
    ){
        count
    }

    DFtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "DF"
            }
        }
    ){
        count
    }

    DFprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "DF"
            }
        }
    ){
        count
    }

    DFcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "DF"
            }
        }
    ){
        count
    }

    EStotal: _allPlayersMeta(
        filter: {
            address: {
                state: "ES"
            }
        }
    ){
        count
    }

    ESprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "ES"
            }
        }
    ){
        count
    }

    EScliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "ES"
            }
        }
    ){
        count
    }

    GOtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "GO"
            }
        }
    ){
        count
    }

    GOprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "GO"
            }
        }
    ){
        count
    }

    GOcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "GO"
            }
        }
    ){
        count
    }

    MAtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "MA"
            }
        }
    ){
        count
    }

    MAprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "MA"
            }
        }
    ){
        count
    }

    MAcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "MA"
            }
        }
    ){
        count
    }

    MTtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "MT"
            }
        }
    ){
        count
    }

    MTprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "MT"
            }
        }
    ){
        count
    }

    MTcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "MT"
            }
        }
    ){
        count
    }

    MStotal: _allPlayersMeta(
        filter: {
            address: {
                state: "MS"
            }
        }
    ){
        count
    }

    MSprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "MS"
            }
        }
    ){
        count
    }

    MScliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "MS"
            }
        }
    ){
        count
    }

    MGtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "MG"
            }
        }
    ){
        count
    }

    MGprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "MG"
            }
        }
    ){
        count
    }

    MGcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "MG"
            }
        }
    ){
        count
    }

    PAtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "PA"
            }
        }
    ){
        count
    }

    PAprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "PA"
            }
        }
    ){
        count
    }

    PAcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "PA"
            }
        }
    ){
        count
    }

    PBtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "PB"
            }
        }
    ){
        count
    }

    PBprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "PB"
            }
        }
    ){
        count
    }

    PBcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "PB"
            }
        }
    ){
        count
    }

    PRtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "PR"
            }
        }
    ){
        count
    }

    PRprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "PR"
            }
        }
    ){
        count
    }

    PRcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "PR"
            }
        }
    ){
        count
    }

    PEtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "PE"
            }
        }
    ){
        count
    }

    PEprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "PE"
            }
        }
    ){
        count
    }

    PEcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "PE"
            }
        }
    ){
        count
    }

    PItotal: _allPlayersMeta(
        filter: {
            address: {
                state: "PI"
            }
        }
    ){
        count
    }

    PIprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "PI"
            }
        }
    ){
        count
    }

    PIcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "PI"
            }
        }
    ){
        count
    }

    RJtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "RJ"
            }
        }
    ){
        count
    }

    RJprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "RJ"
            }
        }
    ){
        count
    }

    RJcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "RJ"
            }
        }
    ){
        count
    }

    RNtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "RN"
            }
        }
    ){
        count
    }

    RNprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "RN"
            }
        }
    ){
        count
    }

    RNcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "RN"
            }
        }
    ){
        count
    }

    RStotal: _allPlayersMeta(
        filter: {
            address: {
                state: "RS"
            }
        }
    ){
        count
    }

    RSprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "RS"
            }
        }
    ){
        count
    }

    RScliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "RS"
            }
        }
    ){
        count
    }

    ROtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "RO"
            }
        }
    ){
        count
    }

    ROprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "RO"
            }
        }
    ){
        count
    }

    ROcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "RO"
            }
        }
    ){
        count
    }

    RRtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "RR"
            }
        }
    ){
        count
    }

    RRprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "RR"
            }
        }
    ){
        count
    }

    RRcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "RR"
            }
        }
    ){
        count
    }

    SCtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "SC"
            }
        }
    ){
        count
    }

    SCprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "SC"
            }
        }
    ){
        count
    }

    SCcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "SC"
            }
        }
    ){
        count
    }

    SPtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "SP"
            }
        }
    ){
        count
    }

    SPprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "SP"
            }
        }
    ){
        count
    }

    SPcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "SP"
            }
        }
    ){
        count
    }

    SEtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "SE"
            }
        }
    ){
        count
    }

    SEprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "SE"
            }
        }
    ){
        count
    }

    SEcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "SE"
            }
        }
    ){
        count
    }

    TOtotal: _allPlayersMeta(
        filter: {
            address: {
                state: "TO"
            }
        }
    ){
        count
    }

    TOprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: {
                state: "TO"
            }
        }
    ){
        count
    }

    TOcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: {
                state: "TO"
            }
        }
    ){
        count
    }
    
    NULLtotal: _allPlayersMeta(
        filter: {
            address: null
        }
    ){
        count
    }

    NULLprofissional: _allPlayersMeta(
        filter: {
            type: PROFISSIONAL
            address: null
        }
    ){
        count
    }

    NULLcliente: _allPlayersMeta(
        filter: {
            type: CLIENTE
            address: null
        }
    ){
        count
    }
}
`

export const CountProposes = `
{
    total: _allProposesMeta{
        count
    }

    aberto: _allProposesMeta(
        filter: {
            status: "Serviço Aberto para Negociação"
        }
    ){
        count
    }

    naorealizado: _allProposesMeta(
        filter: {
            status: "Serviço Não Realizado"
        }
    ){
        count
    }

    recusado: _allProposesMeta(
        filter: {
            status: "Serviço Recusado"
        }
    ){
        count
    }

    aceito: _allProposesMeta(
        filter: {
            status: "Serviço Aceito"
        }
    ){
        count
    }

    cancelado: _allProposesMeta(
        filter: {
            status: "Serviço Cancelado"
        }
    ){
        count
    }

    finalizado: _allProposesMeta(
        filter: {
            status: "Serviço Finalizado com Sucesso"
        }
    ){
        count
    }
}
`

export const CountAnuncios = gql`
{
    _allAnunciosesMeta{
        count
    }
}
`

export const AnunciosAll = gql`
{
    allSkillses {
      name
      _anunciosesMeta {
        count
      }
      anuncioses {
        _proposesMeta {
          count
        }
      }
    }
  }
`

export const CountUsersSetDate = gql`
query ($date: DateTime!){
            _allUsersMeta(filter:{
    createdAt_lte: $date
            }){
              count
            }
            }
`

export const CreateSkills = gql`
mutation CreateSkills($name: String!, $category: ID) {
  createSkill (input: {
      name: $name
    categoryId: $category
  }){
    name
    category {
      name
    }
  }
}
`

export const newHabs = gql`
{
  allHabilidades(filter: {
    cadastro: false
  }) {
    name
  }
}
`

export const CreateCategory = gql`
mutation CreateCategory($name: String!, $description: String, $file: String!){
  createCategory(input: {
      name: $name
    description: $description
    file: $file
  }){
    name
    id
  }
}
`